// @ts-check
// Recorte quadrado da foto ou do logo (doc 10, seção 1.5: upload da imagem identificadora): zoom a partir do maior
// quadrado que cabe na imagem e deslocamento do centro, sempre preso dentro da imagem.

export const MINIMUM_CROP_ZOOM = 1;
export const MAXIMUM_CROP_ZOOM = 4;
export const CROP_OUTPUT_SIZE = 256;

/**
 * Quadrado da imagem original que vira a foto.
 * @param {{ imageWidth: number, imageHeight: number, zoom: number, centerX?: number, centerY?: number }} input
 *   centerX/centerY: centro desejado, em pixels da imagem (padrão: o meio)
 * @returns {{ x: number, y: number, size: number }}
 */
export function computeCropSquare({ imageWidth, imageHeight, zoom, centerX, centerY }) {
  const clampedZoom = Math.min(MAXIMUM_CROP_ZOOM, Math.max(MINIMUM_CROP_ZOOM, Number(zoom) || 1));
  const size = Math.min(imageWidth, imageHeight) / clampedZoom;
  const half = size / 2;
  const clamp = (/** @type {number} */ value, /** @type {number} */ limit) => Math.min(limit - half, Math.max(half, value));
  const x = clamp(centerX ?? imageWidth / 2, imageWidth) - half;
  const y = clamp(centerY ?? imageHeight / 2, imageHeight) - half;
  return { x: Math.round(x * 100) / 100, y: Math.round(y * 100) / 100, size: Math.round(size * 100) / 100 };
}

/**
 * Novo centro depois de arrastar a prévia: arrastar para a direita mostra o que está à esquerda.
 * @param {{ x: number, y: number, size: number }} square @param {number} previewSize lado da prévia na tela, em px
 * @param {number} deltaX @param {number} deltaY deslocamento do ponteiro na tela
 */
export function moveCropCenter(square, previewSize, deltaX, deltaY) {
  const imagePixelsPerScreenPixel = square.size / previewSize;
  return {
    centerX: square.x + square.size / 2 - deltaX * imagePixelsPerScreenPixel,
    centerY: square.y + square.size / 2 - deltaY * imagePixelsPerScreenPixel,
  };
}

/**
 * Endereço da imagem do registro: campo FILES (foto, logo) pela rota de arquivos, TEXT ou LINKS como estão.
 * @param {{ type: string, name: string } | undefined | null} imageField @param {any} record
 * @returns {string | null}
 */
export function getRecordImageUrl(imageField, record) {
  if (!imageField || !record) return null;
  const value = record[imageField.name];
  if (imageField.type === 'FILES') {
    const file = Array.isArray(value) ? value[0] : null;
    if (!file?.fileId) return null;
    return typeof file.url === 'string' && file.url && !file.url.startsWith('/rest/') ? file.url : `/rest/files/${file.fileId}`;
  }
  if (imageField.type === 'TEXT') return typeof value === 'string' && value ? value : null;
  return null;
}
